import { Routes, Route, Navigate, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext.jsx';
import { useAppData } from './context/AppDataContext.jsx';
import { PHASE_LABEL_SHORT, phaseClass } from './phases.js';
import LoginPage from './pages/LoginPage.jsx';
import RegisterPage from './pages/RegisterPage.jsx';
import HomePage from './pages/HomePage.jsx';
import CyclePage from './pages/CyclePage.jsx';
import HeadachePage from './pages/HeadachePage.jsx';
import MedicationsPage from './pages/MedicationsPage.jsx';
import SettingsPage from './pages/SettingsPage.jsx';
import ReportPage from './pages/ReportPage.jsx';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="centered">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PhaseBadge() {
  const { phase } = useAppData();
  return (
    <span className={phaseClass(phase.phase)}>
      {PHASE_LABEL_SHORT[phase.phase] || '—'}
      {phase.dayOfCycle ? ` · g${phase.dayOfCycle}` : ''}
    </span>
  );
}

function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (!user) return children;

  return (
    <div className="layout">
      <header className="topbar">
        <div className="brand">Diario Mal di Testa</div>
        <PhaseBadge />
        <button
          className="btn-link"
          onClick={() => {
            logout();
            navigate('/login');
          }}
        >
          Esci
        </button>
      </header>

      <main className="content">{children}</main>

      <nav className="bottombar">
        <NavLink to="/" end>Oggi</NavLink>
        <NavLink to="/ciclo">Ciclo</NavLink>
        <NavLink to="/mal-di-testa">Mal di testa</NavLink>
        <NavLink to="/medicine">Medicine</NavLink>
        <NavLink to="/report">Report</NavLink>
        <NavLink to="/impostazioni">⚙️</NavLink>
      </nav>
    </div>
  );
}

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/registrati" element={<RegisterPage />} />

        <Route
          path="/"
          element={
            <PrivateRoute>
              <HomePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/ciclo"
          element={
            <PrivateRoute>
              <CyclePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/mal-di-testa"
          element={
            <PrivateRoute>
              <HeadachePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/medicine"
          element={
            <PrivateRoute>
              <MedicationsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/report"
          element={
            <PrivateRoute>
              <ReportPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/impostazioni"
          element={
            <PrivateRoute>
              <SettingsPage />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
